import { useRef } from "react";

const OTPInput = ({ value, onChange }) => {
  const inputsRef = useRef([]);

  const handleInputChange = (e, index) => {
    const val = e.target.value;
    onChange(index, val);

    if (val && /^\d$/.test(val) && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !value[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  return (
    <div className="flex justify-center space-x-2 sm:space-x-3 md:space-x-2 mt-4">
      {Array.from({ length: 6 }).map((_, index) => (
        <input
          key={index}
          ref={(el) => (inputsRef.current[index] = el)}
          type="text"
          maxLength={1}
          value={value[index] || ""}
          onChange={(e) => handleInputChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 text-center border border-gray-300 rounded-md text-lg focus:outline-none focus:ring-2 focus:ring-blue-200 bg-gray-100"
        />
      ))}
    </div>
  );
};

export default OTPInput;
